import { PointSeriesType } from '..';

/**
 * Set markers for orphan data points (points at the end adjacent to one null y-value point, points in the middle between null y-value points)
 * `[1]` is an orphan point.
 * `{ x: 1, y: null }, { x: 2, y: 1 }, { x: 3, y: null }`
 *
 * `[0]` and `[2]` are orphan points.
 * `{ x: 1, y: 1 }, { x: 2, y: null }, { x: 3, y: 1 }`
 * @param series series with object points
 * @returns series with markers enabled for orphan data points
 */
export const handleOrphanDataPoints = (series: PointSeriesType): PointSeriesType => {
  return {
    ...series,
    data: series?.data?.map((point, i, { [i - 1]: previous, [i + 1]: next }) =>
      !Number.isFinite(previous?.y) && Number.isFinite(point.y) && !Number.isFinite(next?.y)
        ? {
            ...point,
            marker: { enabled: true },
          }
        : point,
    ),
  };
};
